import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MessageDialogData } from './message-dialog.model';
import { DomSanitizer } from '@angular/platform-browser';
import * as marked from 'marked';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-message-dialog',
  templateUrl: './message-dialog.html',
  styleUrls: ['./message-dialog.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule
  ],
})
export class MessageDialogComponent implements OnInit {
  icon: string = '';
  htmlMessage?: string;

  constructor(
    public dialogRef: MatDialogRef<MessageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MessageDialogData,
    private sanitizer: DomSanitizer
  ) {
    this.setIcon(data.type || 'info');
  }

  async ngOnInit() {
    if (this.data.markdown) {
      const parsed = await marked.parse(this.data.message); // Await the result
      this.htmlMessage = this.sanitizer.bypassSecurityTrustHtml(parsed) as string;
    }
  }

  setIcon(type: string) {
    const icons: Record<string, string> = {
      info: 'info',
      success: 'check_circle',
      warning: 'warning',
      error: 'error',
      confirm: 'help'
    };
    this.icon = icons[type] || 'info';
  }

  onConfirm(result: boolean) {
    this.dialogRef.close(result);
  }

  onAction(value: unknown) {
    this.dialogRef.close(value);
  }
}
